import React from 'react';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';
const ArticleHeadItem = ({
  article2Title,
  titleSettings,
  titleContainerSettings,
  setOnClickTabAction,
  isSelected,
  dispatch,
  handlerClick,
  index,
  ...rest
}) => {
  return (
    <Box
      {...titleContainerSettings}
      onClick={(e) => {
        setOnClickTabAction();
        handlerClick(e, index);
      }}
    >
      <Text
        {...titleSettings}
        className={`fr-title-article ${isSelected ? 'fr-title-article-selected' : ''}`}
      >
        {article2Title}
      </Text>
    </Box>
  );
};

export default ArticleHeadItem;
